/* Kustom-materiaalivalitsin. Ei riippuvuuksia. Katso snippets/kustom-material-picker.liquid. */
(function () {
  function init(root) {
    if (root.dataset.kmpReady) return;
    root.dataset.kmpReady = '1';
    var optionName = root.dataset.groupOption;

    function groupRadios() {
      return Array.prototype.filter.call(document.querySelectorAll('input[type="radio"]'), function (r) {
        return r.name === optionName && !root.contains(r);
      });
    }

    // Teeman oma Hintaryhmä-valitsin piilotetaan: asiakas valitsee kankaan, ei hintaryhmää.
    function hideGroupOption() {
      groupRadios().forEach(function (r) {
        var box = r.closest('fieldset') || r.parentElement;
        if (box) box.hidden = true;
      });
    }

    function syncGroup(group) {
      var radios = groupRadios();
      if (!group || !radios.length) return;
      var target = radios.filter(function (r) { return r.value === group; })[0];
      if (!target) { console.warn('[kustom] Tuotteelta puuttuu hintaryhmävariantti:', group); return; }
      pick(target);
    }

    // Valitsee teeman varianttiradion ja ilmoittaa teemalle. Teeman variant-radios-elementti voi olla vielä
    // määrittelemättä kun ensimmäinen synkronointi tehdään sivun latautuessa (deferred-skripti), jolloin
    // change-tapahtuma menee hukkaan → samat valinnat ilmoitetaan uudelleen sivun latauduttua.
    var synced = [];
    function pick(target) {
      if (target.checked) return;
      target.checked = true;
      if (synced.indexOf(target) === -1) synced.push(target);
      target.dispatchEvent(new Event('change', { bubbles: true }));
    }
    function resync() {
      synced.forEach(function (r) { if (r.checked) r.dispatchEvent(new Event('change', { bubbles: true })); });
    }
    if (document.readyState === 'complete') setTimeout(resync, 500);
    else window.addEventListener('load', function () { setTimeout(resync, 500); });

    // Jalkaoptio varianttina (Nagu: "Jalka" Tammi/Musta, Roine: "Jalan väri"): jos jalalla on data-variant-value,
    // teeman vastaava varianttivalinta piilotetaan ja sen arvo valitaan jalan mukaan (kuten Hintaryhmä).
    function legVariantRadios() {
      var values = Array.prototype.map.call(root.querySelectorAll('input[name="properties[jalka]"][data-variant-value]'),
        function (i) { return i.dataset.variantValue; });
      if (!values.length) return [];
      return Array.prototype.filter.call(document.querySelectorAll('input[type="radio"]'), function (r) {
        return !root.contains(r) && r.name !== optionName && values.indexOf(r.value) !== -1;
      });
    }
    function hideLegOption() {
      legVariantRadios().forEach(function (r) {
        var box = r.closest('fieldset') || r.parentElement;
        if (box) box.hidden = true;
      });
    }
    function syncLegVariant(value) {
      var target = legVariantRadios().filter(function (r) { return r.value === value; })[0];
      if (target) pick(target);
    }

    function update(name) {
      var input = root.querySelector('input[name="properties[' + name + ']"]:checked');
      var label = root.querySelector('[data-kmp-name="' + name + '"]');
      if (label) label.textContent = input ? input.value : '';
      if (name === 'jalka' && input && input.dataset.variantValue) syncLegVariant(input.dataset.variantValue);
      if (name !== 'materiaali' || !input) return;
      var group = root.querySelector('[data-kmp-group]');
      var hasGroups = groupRadios().length > 0;
      if (group) group.textContent = hasGroups && input.dataset.group ? '(' + input.dataset.group + ')' : '';
      var later = root.querySelector('[data-kmp-later]');
      if (later) later.hidden = input.dataset.type !== 'erikois';
      syncGroup(input.dataset.group);
      // 3D-katselin ja muut kuuntelijat voivat reagoida kankaan vaihtoon.
      document.dispatchEvent(new CustomEvent('kustom:material-change', {
        detail: { name: input.value, group: input.dataset.group, type: input.dataset.type, serie: input.dataset.serie,
                  repeatFactor: Number(input.dataset.repeatFactor) || 1,
                  image: input.dataset.img, texture: input.dataset.texture || null }
      }));
    }

    root.addEventListener('change', function (e) {
      var m = /^properties\[(.+)\]$/.exec(e.target.name || '');
      if (!m) return;
      update(m[1]);
      document.dispatchEvent(new CustomEvent('kustom:option-change', { detail: { name: m[1], value: e.target.value } }));
    });
    init3d(root);
    hideGroupOption();
    hideLegOption();
    update('materiaali');
    update('jalka');
  }

  // ---- 3D-katselin (model-viewer). Kamera ei laske vaakatason alle (max 87 astetta). ----
  var MODEL_VIEWER_SRC = 'https://ajax.googleapis.com/ajax/libs/model-viewer/3.5.0/model-viewer.min.js';

  function init3d(root) {
    var box = root.querySelector('[data-kmp3d]');
    if (!box) return;
    var media = document.querySelector('.product-wrapper');
    if (media) media.insertBefore(box, media.firstChild);
    if (!window.customElements.get('model-viewer') && !document.querySelector('script[data-kmp-mv]')) {
      var s = document.createElement('script');
      s.type = 'module'; s.src = MODEL_VIEWER_SRC; s.setAttribute('data-kmp-mv', '');
      document.head.appendChild(s);
    }
    var mv = document.createElement('model-viewer');
    var attrs = { src: box.dataset.src, alt: box.dataset.alt || '', loading: 'eager', 'camera-controls': '', 'touch-action': 'pan-y',
      'camera-orbit': '30deg 72deg auto', 'max-camera-orbit': 'auto 87deg auto', 'shadow-intensity': '1',
      'environment-image': 'neutral', 'interaction-prompt': 'none', ar: '', 'ar-modes': 'webxr scene-viewer quick-look' };
    Object.keys(attrs).forEach(function (k) { mv.setAttribute(k, attrs[k]); });
    box.appendChild(mv);

    var repeat = Number(box.dataset.repeat) || 6, neutral = null, seq = 0;
    var material = null, side = null;

    // Vaihtoehtoiset mallit varianttioption mukaan (Haihara: Helma = Helmalla / Ilman helmaa). Tuotteen metakenttä
    // kustom.malli_3d_vaihtoehdot: {"optio": "Helma", "mallit": {"Helmalla": url, "Ilman helmaa": url}}.
    var alt = null;
    try { alt = box.dataset.altModels ? JSON.parse(box.dataset.altModels) : null; } catch (err) { alt = null; }
    function optionValue(name) {
      var r = document.querySelector('input[name="' + name + '"]:checked');
      if (r) return r.value;
      var s = document.querySelector('select[name="' + name + '"]');
      return s ? s.value : null;
    }
    function applyModel() {
      if (!alt || !alt.optio || !alt.mallit) return;
      var v = optionValue(alt.optio), url = v && alt.mallit[v];
      if (!url || mv.getAttribute('src') === url) return;
      neutral = null;
      var prev = mv.model ? mv.model.materials[0] : null;
      mv.setAttribute('src', url);
      waitModel(prev, reapply);
    }
    // model-viewer ei luotettavasti laukaise load-tapahtumaa (ei mallin vaihdossa eikä aina ensilatauksessa),
    // joten uutta mallia odotetaan kyselemällä ja kangas, jalat ja kätisyys asetetaan siihen sitten.
    function waitModel(prev, cb) {
      var tries = 0, timer = setInterval(function () {
        if (mv.loaded && mv.model && mv.model.materials.length && mv.model.materials[0] !== prev) { clearInterval(timer); cb(); }
        else if (++tries > 200) clearInterval(timer);
      }, 150);
    }
    document.addEventListener('change', function (e) {
      if (alt && e.target && e.target.name === alt.optio) applyModel();
      if (box.dataset.sideOption && e.target && e.target.name === box.dataset.sideOption) { readCurrent(); applySide(); }
    });

    // Säätötila: lisää osoitteeseen ?kmp_saato=1, niin katselimen alle tulee liukusäädin, jolla sarjan
    // toistokerrointa voi kokeilla. Löydetty arvo kirjataan metaobjektiin Kangassarja > 3D-toiston kerroin.
    var tuned = {}, tuner = null;
    if (/[?&]kmp_saato=1/.test(location.search)) {
      var panel = document.createElement('div');
      panel.className = 'kmp3d__tuner';
      panel.innerHTML = '<label>3D-toiston kerroin <strong data-s></strong>: <input type="range" min="0.2" max="5" step="0.1"> <output></output></label>' +
        '<small>Tuotteen perustoisto ' + repeat + '. Kirjaa arvo: Content > Metaobjects > Kangassarja.</small>';
      box.appendChild(panel);
      var range = panel.querySelector('input'), out = panel.querySelector('output'), label = panel.querySelector('[data-s]');
      tuner = { show: function (m) { var v = tuned[m.serie] || m.repeatFactor || 1; label.textContent = m.serie || ''; range.value = v; out.textContent = v; } };
      range.addEventListener('input', function () {
        if (!material || !material.serie) return;
        tuned[material.serie] = Number(range.value); out.textContent = range.value; applyMaterial();
      });
    }

    function fabric() {
      if (!mv.model) return null;
      return mv.model.materials.filter(function (m) { return m.name === 'kangas'; })[0] || null;
    }
    function applyMaterial() {
      var mat = fabric();
      if (!mat || !material) return;
      var pbr = mat.pbrMetallicRoughness;
      if (!neutral) neutral = pbr.baseColorFactor.slice();
      var url = material.type === 'erikois' ? null : (material.texture || material.image);
      var token = ++seq;
      if (!url) { pbr.baseColorTexture.setTexture(null); pbr.setBaseColorFactor(neutral); return; }
      if (url.indexOf('//') === 0) url = location.protocol + url;
      mv.createTexture(url).then(function (tex) {
        if (token !== seq) return;
        pbr.setBaseColorFactor([1, 1, 1, 1]);
        pbr.baseColorTexture.setTexture(tex);
        // Toisto on asetettava vasta kiinnitetyn tekstuurin samplerille, muuten se ei tule voimaan.
        // Peilaava toisto (33648 = MIRRORED_REPEAT) häivyttää swatch-valokuvien reunat, jolloin ruudutusta ei näy.
        var sampler = pbr.baseColorTexture.texture.sampler;
        sampler.setWrapS(33648); sampler.setWrapT(33648);
        var n = repeat * (tuned[material.serie] || material.repeatFactor || 1);
        sampler.setScale({ u: n, v: n });
        if (tuner) tuner.show(material);
      }).catch(function (err) { console.warn('[kustom] Kankaan lataus 3D-malliin ei onnistunut', err); });
    }
    // Jalat: GLB:ssä on kaksi jalkasarjaa (materiaalit jalat_puu ja jalat_metalli, alphaMode MASK).
    // Valittu sarja näytetään ja värjätään, toinen piilotetaan asettamalla alfa nollaan.
    function srgbToLinear(hex) {
      var m = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(hex || '');
      if (!m) return null;
      return [1, 2, 3].map(function (i) {
        var c = parseInt(m[i], 16) / 255;
        return c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
      });
    }
    function applyLegs() {
      if (!mv.model) return;
      var input = root.querySelector('input[name="properties[jalka]"]:checked');
      // Tuotteella ei ole jalkavalikoimaa (esim. Haihara istuinosa ja rahi): näytetään oletusjalka, jonka snippet
      // antaa muodossa data-default-leg="puu|#c49a6c" (kartiojalka tammi).
      var def = (box.dataset.defaultLeg || 'puu|').split('|');
      var type = input ? (input.dataset.legType || 'puu') : def[0];
      var rgb = srgbToLinear(input ? input.dataset.legColor : def[1]);
      // Jalkasarja voi puuttua kokonaan (Haihara, Nagu, Roine): materiaali on GLB:ssä mutta mikään mesh ei
      // käytä sitä, jolloin model-viewer ei lataa sitä ja sen ominaisuuksien lukeminen heittää virheen.
      var sets = [['jalat_puu', 'puu'], ['jalat_metalli', 'metalli']].map(function (pair) {
        var mat = mv.model.materials.filter(function (m) { return m.name === pair[0]; })[0];
        return mat && mat.isLoaded !== false ? { mat: mat, type: pair[1] } : null;
      }).filter(Boolean);
      sets.forEach(function (set) {
        // Jos mallissa on vain yhdet jalat, ne pidetään aina näkyvissä ja vain väri vaihtuu.
        var mat = set.mat, visible = sets.length === 1 || set.type === type;
        var pbr = mat.pbrMetallicRoughness, c = pbr.baseColorFactor.slice();
        if (visible && rgb) { c[0] = rgb[0]; c[1] = rgb[1]; c[2] = rgb[2]; }
        c[3] = visible ? 1 : 0;
        mat.setAlphaMode('MASK'); mat.setAlphaCutoff(0.5);
        pbr.setBaseColorFactor(c);
      });
    }
    function applySide() {
      if (side === null) return;
      var wantLeft = side === box.dataset.sideLeft;
      var nativeLeft = box.dataset.nativeSide === 'vasen';
      mv.setAttribute('scale', wantLeft !== nativeLeft ? '-1 1 1' : '1 1 1');
    }
    function readCurrent() {
      var f = root.querySelector('input[name="properties[materiaali]"]:checked');
      if (f) material = { type: f.dataset.type, image: f.dataset.img, texture: f.dataset.texture || null,
                          serie: f.dataset.serie, repeatFactor: Number(f.dataset.repeatFactor) || 1 };
      var k = root.querySelector('input[name="properties[' + box.dataset.sideName + ']"]:checked');
      if (k) side = k.value;
      // Kätisyys varianttioptiosta (divaanit: Käsinoja = Vasen käsinoja / Oikea käsinoja).
      if (box.dataset.sideOption) {
        var v = optionValue(box.dataset.sideOption);
        if (v) side = /vasen/i.test(v) ? box.dataset.sideLeft : '__oikea';
      }
    }
    document.addEventListener('kustom:material-change', function (e) { material = e.detail; applyMaterial(); });
    document.addEventListener('kustom:option-change', function (e) {
      if (e.detail.name === box.dataset.sideName) { side = e.detail.value; applySide(); }
      if (e.detail.name === 'jalka') applyLegs();
    });
    function reapply() { readCurrent(); applyMaterial(); applySide(); applyLegs(); }
    mv.addEventListener('load', reapply);
    readCurrent(); applySide(); applyModel();
    waitModel(null, reapply);
  }

  function boot() { document.querySelectorAll('[data-kmp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
